import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentResult() {
  const { status } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (status !== "success") { setState("cancelled"); return; }
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch {}
      attempts += 1;
      if (attempts < 12) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [status, params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="payment-result">
      <div className="max-w-md w-full text-center rounded-3xl border border-border bg-card p-12">
        {(state === "checking") && (
          <>
            <Loader2 size={36} className="mx-auto text-electric animate-spin mb-6" />
            <h1 className="font-display font-bold text-2xl mb-2">{t("payment.checking")[0]}</h1>
            <p className="text-sm text-muted-foreground">{t("payment.checking")[1]}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={40} className="mx-auto text-success mb-6" />
            <h1 className="font-display font-bold text-2xl mb-2">{t("payment.paid")[0]}</h1>
            <p className="text-sm text-muted-foreground mb-8">{t("payment.paid")[1]}</p>
            <button onClick={() => navigate("/app")} data-testid="payment-success-continue"
              className="rounded-full bg-electric text-white px-8 py-3 text-sm font-bold hover:bg-blue-700 transition-colors">
              {t("payment.paid")[2]}
            </button>
          </>
        )}
        {(state === "cancelled" || state === "error" || state === "timeout") && (
          <>
            <XCircle size={40} className="mx-auto text-warning mb-6" />
            <h1 className="font-display font-bold text-2xl mb-2">
              {state === "cancelled" ? t("payment.cancelled")[0] : t("payment.pending")[0]}
            </h1>
            <p className="text-sm text-muted-foreground mb-8">
              {state === "cancelled" ? t("payment.cancelled")[1] : t("payment.pending")[1]}
            </p>
            <Link to="/app/compte" data-testid="payment-cancel-back"
              className="rounded-full border border-border px-8 py-3 text-sm font-semibold hover:border-electric/50 transition-colors inline-block">
              {t("payment.back")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
